import { PlusIcon, XMarkIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';
import AddInformationDialogBox from '../AddInformationDialogBox';
import { useDispatch, useSelector } from 'react-redux';
import { deleteValueAction } from '../../../reduxstore/actions/quoteActions';

const InformationCardRow = ({ editing, type, heading }) => {
  const dispatch = useDispatch();
  const data = useSelector((state) =>
    state?.quoteReducer?.quote?.[type]?.data?.find(
      (item) => item.heading === heading,
    ),
  );
  const [editParticular, setEditParticular] = useState(false);
  const [dialogBox, setDialogBox] = useState(false);

  const handledelete = (index) => {
    dispatch(deleteValueAction(type, data?.heading, index));
  };

  return (
    <div>
      <div key={data?.heading} className="grid grid-cols-4 mt-5 items-center">
        <div className="text-black text-[18px] text-left font-bold">
          {data?.heading} :
        </div>
        <div className="flex flex-row justify-between col-span-3 items-center">
          <div className="flex flex-row flex-wrap items-center">
            {editParticular && editing ? (
              <div className="flex flex-wrap">
                {data?.value &&
                  data?.value.map((item, index) => (
                    <div
                      key={index}
                      className="flex items-center m-1 px-1 bg-[#D9D9D9] rounded-full hover:cursor-default"
                    >
                      <div className="bg-[#D9D9D9] rounded-full px-1 ">
                        {item}
                      </div>
                      <XMarkIcon
                        className="block h-4 w-4 font-bold hover:cursor-pointer"
                        aria-hidden="true"
                        onClick={() => handledelete(index)}
                      />
                    </div>
                  ))}
              </div>
            ) : (
              <div className="text-black text-[16px] text-left items-center hover:cursor-default">
                {data?.value?.join(', ')}
              </div>
            )}
          </div>

          {editing && (
            <div className="relative">
              <div className="flex items-center">
                {dialogBox && (
                  <div className="absolute right-8 top-0">
                    <AddInformationDialogBox
                      heading={data?.heading}
                      type={type}
                    />
                  </div>
                )}

                {dialogBox ? (
                  <XMarkIcon
                    className="block h-6 w-6 hover:cursor-pointer text-blue-400"
                    aria-hidden="true"
                    onClick={() => {
                      setDialogBox(!dialogBox);
                      setEditParticular(!editParticular);
                    }}
                  />
                ) : (
                  <PlusIcon
                    className="block h-6 w-6 hover:cursor-pointer"
                    aria-hidden="true"
                    onClick={() => {
                      setDialogBox(!dialogBox);
                      setEditParticular(!editParticular);
                    }}
                  />
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default InformationCardRow;
